import { render, staticRenderFns } from "./OTParcelCustomer.vue?vue&type=template&id=3612df1f&"
import script from "./OTParcelCustomer.vue?vue&type=script&lang=js&"
export * from "./OTParcelCustomer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports